<template>
  <!-- <transition name="fade"> -->
  <div>
    <div
      v-if="_.get($store.state.main.selected_menu, 'id') && layout_loaded"
      class="page-wrapper"
    >
      <ComplaintModal />
      <VacancyModal />
      <LeadModal  />
      <DownloadModal />
      <PortalTarget name="modal" multiple></PortalTarget>
      <HeaderScrolled />
      <Cookies />
      <ConfigureCookies />
      <GetYourPrice />

      <transition name="fade">
        <div class="overlay__global bg-white" v-if="overlay_on"></div>
      </transition>
      <component
        :is="selectedLayout"
        :key="selectedLayout"
        v-if="selectedLayout"
      />
    </div>
    <Error
      v-if="
        !_.get($store.state.main.selected_menu, 'id') &&
          layout_loaded &&
          $store.state.main.selected_menu.id === undefined
      "
    />
  </div>
  <!-- </transition> -->
  <!-- <div>
       <router-view />
    </div> -->
</template>

<script>
import mainMixin from "@/mixins/main";
import pageRouting from "@/mixins/pageRouting";
import HeaderScrolled from "@/components/modules/HeaderScrolled";
import Cookies from "@/components/modules/Cookies";
import VacancyModal from "@/components/modals/VacancyModal";
import LeadModal from "@/components/modals/LeadModal";

import ComplaintModal from "@/components/modals/ComplaintModal";
import GetYourPrice from "@/components/modals/GetYourPrice";
import DownloadModal from "@/components/modals/DownloadModal";
import ConfigureCookies from "@/components/modals/ConfigureCookies";
import Error from "./views/layouts/Error";
import StickyButton from "./components/smartComponents/StickyButton.vue";

export default {
  name: "App",
  mixins: [mainMixin, pageRouting],
  components: {
    HeaderScrolled,
    Cookies,
    VacancyModal,
    ComplaintModal,
    DownloadModal,
    LeadModal,
    ConfigureCookies,
    GetYourPrice,
    Error,
    StickyButton
  },
  metaInfo() {
    let titleData =
      _.get(this.$store.state.main.selected_menu, "seo.title") ||
      _.get(this.$store.state.main.selected_menu, "title") ||
      _.get(this.$store.state.main.indx, "siteSettings.website_title");

    if (_.get(this.$store.state.main.selected_menu, "seo.title"))
      titleData = _.get(this.$store.state.main.selected_menu, "seo.title");
    const contentTitle =
      _.get(this.$store.state.main.selected_menu, "seo.title") ||
      _.get(this.$store.state.main.selected_menu, "title");
    const description =
      _.get(this.$store.state.main.selected_menu, "seo.description") ||
      _.get(
        this.$store.state.main.indx,
        "siteSettings.website_meta_description"
      );
    const keyword =
      _.get(this.$store.state.main.selected_menu, "seo.keywords") ||
      _.get(this.$store.state.main.indx, "siteSettings.website_meta_keywords");
    // if no subcomponents specify a metaInfo.title, this title will be used

    return {
      title: contentTitle,
      // all titles will be injected into this template
      titleTemplate: titleData,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: description
        },
        {
          vmid: "keyword",
          name: "keyword",
          content: keyword
        }
      ]
    };
  },

  data() {
    return {
      selectedLayout: "",
      overlay_on: true
    };
  },

  mounted() {
    this.$store.dispatch("main/getBulkData", {
      node: "servicesMap",
      key: "servicesMap"
    });

    if (this.$route.name && this.$route.name.indexOf("PageViewRouter") >= 0)
      this.$store.commit("main/setState", { key: "showSite", val: true });
  },

  watch: {
    "$store.state.cache": {
      immediate: true,
      deep: true,
      handler() {
        // console.log(111, this.$store.state.main.cache);
      }
    },
    $route: {
      immediate: true,
      deep: true,
      handler: function() {
        this.pageRoutingSelectMenuByPath();
        if (this.$route.name === "PageViewRouter_ge") {
          document.querySelector("html").setAttribute("lang", "ka");
        } else {
          document.querySelector("html").setAttribute("lang", "en");
        }
      }
    },

    "$store.state.main.selected_menu.id": {
      immediate: true,
      handler(ns) {
        this.setLayoutTemplate();

        console.log(ns);

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      }
    },

    "$store.state.main.layout_loaded": {
      immediate: true,
      handler(ns) {
        console.log(ns); 
      }
    },
    "$store.state.main.current_content_request_status"(ns, os) {
      if (ns === "done") {
        setTimeout(() => {
          this.overlay_on = false;
          this.$map_key = this.$store.state.main.indx.siteSettings.google_map_key;
        }, 1000);
        setTimeout(() => {
          if (
            this.$store.state.main.selected_menu.configs.includes(
              "contact_page"
            )
          ) {
            document.querySelector("body").className = "contact_page";
          }
        }, 600);
      }
    },
    "$store.state.main.indx.smartLayouts": {
      handler() {
        this.importLayouts();
        this.pageRoutingSelectMenuByPath();
        this.setLayoutTemplate();

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      }
    }
  },

  methods: {
    importLayouts() {
      /// dinamicaly import all layouts as components
      let components = _.get(this.$store.state.main.indx, "smartLayouts");

      for (let i in components) {
        this.$options.components[i] = () => import("./views/layouts/" + i);
      }
      return true;
    },

    /// set layout template depend on selected_menu.currentLayoutTemplate
    setLayoutTemplate() {
      if (
        this.$options.components[
          _.get(this.$store.state.main.selected_menu, "currentLayoutTemplate")
        ]
      ) {
        this.selectedLayout = this.$store.state.main.selected_menu.currentLayoutTemplate;
      }
    }
  },

  computed: {
    layout_loaded() {
      return this.$store.state.main.layout_loaded;
    }
  }
};
</script>
<style></style>
